// Why the cashier did not register the physical card of a gift-card sale (PAUL-3807). Sent by the
// backend as its integer value: append, never renumber.
export enum GiftCardSkipReason {
  NoCardAtHand = 0,
  SaleRungUpWrong = 1,
  CodeNotAccepted = 2,
  Other = 3,
}

export const giftCardSkipReasonTranslations: Record<GiftCardSkipReason, string> = {
  [GiftCardSkipReason.NoCardAtHand]: 'orders.gift_card_skip_reasons.no_card_at_hand',
  [GiftCardSkipReason.SaleRungUpWrong]: 'orders.gift_card_skip_reasons.sale_rung_up_wrong',
  [GiftCardSkipReason.CodeNotAccepted]: 'orders.gift_card_skip_reasons.code_not_accepted',
  [GiftCardSkipReason.Other]: 'orders.gift_card_skip_reasons.other',
};
